import apkDownload from "../assets/images/footer/apkDownload.svg";

// TEMPORARY: the Play Store listing is unpublished, so the APK button is shown
// in place of the Play Store badge. Set to true once it is live again.
// (The App Store badge is unaffected.)
export const PLAY_STORE_LIVE = false;

export const APK_DOWNLOAD_URL =
  "https://drive.google.com/file/d/1bMW8BfXpl6dFeFwafvI_HJM6VdwqRsfb/view?usp=sharing";

// apkDownload.svg uses the same canvas as playStore.png (528x204, transparent
// margin included), so it drops in with the same width/style as that <img>.
const DownloadApkButton = ({ width = 145, style }) => (
  <img
    src={apkDownload}
    style={{ width, cursor: "pointer", ...style }}
    alt="Button to Download Me Books Android App (APK)"
    onClick={() => {
      window.open(APK_DOWNLOAD_URL);
    }}
  />
);

export default DownloadApkButton;
